import React from 'react';
import Icon from '@vtblife/uikit-icons';
import { EventBus } from '@vtblife/event-bus';

import { NavbarMenuItem } from '@vtblife/layout-config/types';

import styles from './navbar-button.module.css';
import { sendAnalyticsEvent } from '../../../analytics';

interface NavbarButtonProps {
    item: NavbarMenuItem;
}

export const NavbarButton = ({ item }: NavbarButtonProps) => {
    const { title, icon, analytics, payload, action } = item;

    const clickHandler = () => {
        if (analytics) {
            sendAnalyticsEvent(analytics);
        }
        if (action) {
            EventBus.getInstance().publish({
                category: 'simple',
                type: action,
                data: payload || {},
            });
        }
    };

    return (
        <button type="button" className={styles.link} onClick={clickHandler}>
            <span className={styles.icon}>
                <Icon name={icon as any} />
            </span>
            <span className={styles.title}>{title}</span>
        </button>
    );
};
